import { render, staticRenderFns } from "./SimpleView.vue?vue&type=template&id=046ac4aa&"
import script from "./SimpleView.vue?vue&type=script&lang=ts&"
export * from "./SimpleView.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports